<template>
	<div class="prices pricesEdit">
		<b-card-group deck>
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<span class="hide-print">
						<h5>{{$t('pricing.editTitle')}}</h5>
					</span>
					<b-button variant="outline" @click.prevent="closeSidebar" class="hide-print">
						<i class="fa fa-close"></i>
					</b-button>
				</div>
				<b-form>
					<div class="row" style="display: flex;justify-content: flex-end;">
						<div class="col-3 btn-frame" style="margin-left: -50px">
							<download-excel
								size="sm"
								class="btn btn-success"
								:data="items.pricingItems"
								:fields="json_fields1"
								worksheet="My Worksheet"
								name="Excel">
								{{$t('excel-export.download-excel')}}
							</download-excel>
						</div>
						<div class="btn-frame col-2">
							<b-button variant="outline-info" class="hide-print" @click.prevent="printFunc">
								<i class="fa fa-print"></i> &nbsp;
								<span>{{$t('pricing.print')}}</span>
							</b-button>
						</div>
						<div class="col-3">
							<b-button
								variant="outline-dark"
								@click="generateBarcode"
								class="hide-print"

							>
								<i class="fa fa-print"></i>
								{{$t('pricing.print')}} {{$t('goods.barcode')}}
							</b-button>
						</div>

					</div>
					<div class="top-form">
						<b-container fluid>
							<b-row class="my-1">
								<b-col sm="3">
									<label for="input-small">{{$t('pricing.registrationNo')}}</label>
									<b-input-group
										size="sm"
										class="mb-3"
									>
										<b-form-input
											:placeholder="$t('pricing.registrationNo')"
											:state="isValid"
											:value="this.items.costNumber"
											disabled
											class="noborder-print"
										>
										</b-form-input>
										<b-input-group-append>
											<b-button
												size="sm"
												text="Button"
												class="hide-print"
												variant="success"
												disabled
											>
												<i class="fa fa-refresh"></i>
											</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-col>
								<b-col sm="3">
									<label for="input-small">
										{{$t('pricing.costDate')}}
									</label>
									<b-form-input
										id="input-small"
										type="text"
										size="sm"
										:value="this.items.costDate"
										disabled
										class="noborder-print"
									>
									</b-form-input>
								</b-col>
								<b-col sm="3" class="widerForPrint">
									<label for="input-small">
										{{$t('pricing.department')}}
									</label>
									<multiselect
										:value="this.items.companies"
										:options="options"
										placeholder="Select one"
										label="name"
										track-by="id"
										:multiple="true"
										:disabled="true"
										class="departmentsMultiselect"
									>
									</multiselect>
									<div class="departmentPrint">
										<span
											v-for="(department,index) in this.items.companies">{{index + 1}}. {{department.name}}</span>
									</div>
								</b-col>
								<b-col sm="3" class="hideFilterInput">
									<label for="input-small" style="display: block;">
										{{$t('contragent.filter')}}
									</label>
									<div class="searchInCard">
										<b-input-group size="sm">
											<b-form-input v-model="filter" size="sm"
														  :placeholder="$t('contragent.filter')"/>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">
													{{$t('contragent.clear')}}
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</div>
								</b-col>
							</b-row>
						</b-container>
					</div>
					<b-modal
						:hide-footer="true"
						:title="$t('barcode-count')"
						v-model="openMocalCount"
						@ok="generateBarcodeScan"
						size="lg"
					>

						<div v-if="openMocalCount">
							<BarcodeModal
								@cancel="closeReturnModal"
								@ok="generateBarcodeScan"
								:items="calculateCount">
								<h4>Возврат?</h4>
							</BarcodeModal>
						</div>
					</b-modal>
					<b-table class="generalTableClass print-size" :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 :filter="filter"
							 :items="items.pricingItems"
							 responsive="sm" :fields="computedFields">

						<template slot="number" slot-scope="data">
							<strong>{{ data.index + 1 }}</strong>
						</template>

						<template slot="details" slot-scope="data">
							{{ data.item.name }} / <strong>{{ data.item.colorName }} /
							{{ data.item.size }}</strong>
						</template>

						<template slot="barcode" slot-scope="data">
							{{ data.item.barcode }}
						</template>

						<template slot="artikul" slot-scope="data">
							{{ data.item.artikul }}
						</template>

						<template slot="incomeUzs" slot-scope="data">
						<span v-if="data.item.incomeUzs > 0">
									{{data.item.incomeUzs | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
							<span v-else> </span>
						</template>
						<template slot="uzb" slot-scope="data">
								<span v-if="data.item.priceUzs > 0">
									{{data.item.priceUzs | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
							<span v-else> </span>
						</template>
						<template slot="lastPriceWholesale" slot-scope="data">
								<span v-if="data.item.priceWholesale > 0">
									{{data.item.priceWholesale | currency({
								symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
							<span v-else> </span>
						</template>
					</b-table>
					<div class="col-4 pl-0">
						<b-form-textarea
							style="height: 50px;"
							id="textarea"
							:value="this.items.comment"
							disabled
							placeholder="Комментарий"
							rows="3"
							max-rows="6"
						></b-form-textarea>


					</div>

				</b-form>
			</b-card>
		</b-card-group>

	</div>
</template>

<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import Multiselect from 'vue-multiselect'
	import BarcodeModal from "./BarcodeModal";

	export default {
		components: {
			BarcodeModal,
			Multiselect
		},
		directives: {
			focus: {
				inserted: function (el) {
					el.focus()
				}
			}
		},
		data() {
			return {
				json_fields1: {
					'Документ дата': 'docDate',
					'Документ №': 'docNumber',
					'Название': 'name',
					'Цвет': 'colorName',
					'Штрихкод': 'barcode',
					'Артикул': 'artikul',
					'Цена (приход)': 'incomeUzs',
					'Розничная цена (последняя)': 'priceUzs',
					'Оптовая цена (последняя)': 'priceWholesale'
				},
				openMocalCount: false,
				count: 0,
				currency: '',
				depCurrencyName: '',
				filter: '',
				items: [],
				currentDate: '',
				selectedDepartment: '',
				isValid: '',
				ok: false,
				regnumber: '',
				activeSidebar: false,
				value: [],
				options: []
			}
		},
		mounted() {

		},
		props: {
			caption: {
				type: String,
				default: 'Users'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			getEditItems: {
				handler() {
					this.items = this.getEditItems;
					this.currency = this.getEditItems.companies[0].currencyCode;
					this.depCurrencyName = this.getEditItems.companies[0].currencyName;
				}
			}
		},
		computed: {
			...mapState(['userDepCurrencyName']),
			...mapGetters('prices', [
				'getEditItems'
			]),
			...mapState('prices', [
				'comment'
			]),
			calculateCount() {
				var result = this.items.pricingItems.map(function (el) {
					var o = Object.assign({}, el);
					o.count = 1;
					return o;
				})
				return result;
			},
			computedFields() {
				return [
					{
						key: 'number',
						label: '№',
						sortable: true
					},
					{
						key: 'docDate',
						label: this.$t('prices.item.docDate')
					},
					{
						key: 'docNumber',
						label: this.$t('prices.item.docNumber')
					},
					{
						key: 'details',
						label: this.$t('prices.item.details'),
						'class': 'width12rem',
					},
					{
						key: 'barcode',
						label: this.$t('goods.barcode'),

					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),

					},
					{
						key: 'incomeUzs',
						label: this.$t('prices.item.sum'),
						'class': 'width8Percent',
					},
					{
						key: 'lastPriceWholesale',
						label: this.$t('prices.item.lastPriceWholesale'),
						'class': 'width8Percent',
					},
					{
						key: 'uzb',
						label: this.$t('prices.item.lastPriceUzs'),
						'class': 'width8Percent',
					}
				]
			},
		},
		methods: {

				closeReturnModal() {
				this.openMocalCount = false;
			},
			addItemsForReturn() {
			},
			async generateBarcodeScan(items) {
				await this.$emit('closeSidebar');
				this.$store.commit('prices/setPricingForBarcode', items);
				await this.$router.push(`/point-of-sale/pos/barcode`);
			},
			async generateBarcode() {
				this.openMocalCount = true;
			},
			printFunc() {
				window.print();
			},
			...mapActions('prices', [
				'getUpdatePricing', 'getEditPricing'
			]),
			closeSidebar() {
				this.ok = false
				this.$emit('closeSidebar')
			},
			async onUpdate() {
				const result = this.items.pricingItems.map((item) => {
					return {
						itemId: item.id,
						pricingId: item.pricingItemId,
						priceEur: item.priceEur,
						priceRub: item.priceRub,
						priceUzs: item.priceUzs,
						priceUsd: item.priceUsd,
					};
				});
				const data = {
					id: this.items.id,
					costNumber: this.items.costNumber,
					costDate: this.items.costDate,
					departmentId: this.items.departmentId,
					departmentName: this.items.departmentName,
					pricingItems: result
				}
				this.getUpdatePricing(data)
				this.ok = false
				this.$emit('closeSidebar')

			},
			focusInput($event, index, inputOrder) {

				let lastIndex = this.items.pricingItems.length - 1;

				//left
				if ($event.keyCode == 37) {
					if (inputOrder == 1 && index == 0) {
						return 1
					}
					if (inputOrder == 1 && index != 0) {
						const refName = (index - 1).toString() + '4'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					if (inputOrder == 4) {
						const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				// right
				if ($event.keyCode == 39) {
					if (inputOrder == 4 && lastIndex == index) {
						return 1
					}
					if (inputOrder == 4 && lastIndex != index) {
						const refName = (index + 1).toString() + '1'
						this.$refs[refName].$el.focus()
						this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
						return
					}
					const refName = index.toString() + (parseInt(inputOrder) + 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}

				// up
				if ($event.keyCode == 38) {
					if (index == 0) {
						return 1
					}
					const refName = (index - 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}
				// down
				if ($event.keyCode == 40) {
					if (index == lastIndex) {
						return 1
					}
					const refName = (index + 1).toString() + (inputOrder).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				}

			},
			async OkFunction(refName) {
				await this.changeOk();
				await this.focusRef(refName)
			},
			changeOk() {
				this.ok = true;
				return true
			},
			focusRef(refName) {
				this.$refs[refName].focus();
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				return true;
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

@page  {
	margin: 1cm;
}

	@media print {
		.widerForPrint {
			flex: 0 0 50%;
			max-width: 50%;
		}

		.hideFilterInput {
			display: none !important;
		}

		.departmentPrint {
			display: block !important;
		}

		.departmentsMultiselect {
			display: none !important;
		}

		.departmentPrint span {
			margin-right: 10px !important;
		}

		.prices {
			font-size: 16px;
		}

		.hide-print {
			display: none;
		}

		.noborder-print {
			border: none;
			box-shadow: none;
		}
	}

	/*.generalTableClass{*/
	/*white-space: nowrap;*/
	/*overflow-x: scroll;*/
	/*}*/
	.departmentsMultiselect {
		display: block;
	}

	.departmentPrint {
		display: none;
	}

	/*.inputWidth {*/
	/*width: 152px;*/
	/*height: 16px;*/
	/*text-align: center;*/
	/*}*/
	.btn-frame {
		display: flex;
		justify-content: flex-end;
	}

	.move {
		height: 20px !important;
		margin-left: 2px;
	}

	.top-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	th {
		text-align: center !important;
	}

	.departments {
		display: flex;
		flex-wrap: wrap;
	}
</style>
